
export enum WeekDays {
    Sunday = 1,
    Monday = 2,
    Tuesday = 4,
    Wednesday = 8,
    Thursday = 16,
    Friday = 32,
    Saturday = 64
}

export const WeekDaysMetadata = {
    '1' : {
        display: 'Sunday',
        value: 1
    },
    '2' : {
        display: 'Monday',
        value: 2
    },
    '4' : {
        display: 'Tuesday',
        value: 4
    },
    '8' : {
        display: 'Wednesday',
        value: 8
    },
    '16' : {
        display: 'Thursday',
        value: 16
    },
    '32' : {
        display: 'Friday',
        value: 32
    },
    '64' : {
        display: 'Saturday',
        value: 6
    }
}